import svg4everybody from 'svg4everybody';
// import $ from 'jquery'

svg4everybody();

// window.$ = $
// window.jQuery = $

import './vendor/simplebar';
import './vendor/masked-input';
